window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  init: function() {

    var selectors = {
      cartPopup: '[data-cart-popup]',
      cartPopupOverlay: '[data-cart-popup-overlay]',
      cartPopupItems: '[data-cart-popup-items]',
      cartPopupClose: '[data-cart-popup-close]'
    };

    var _this = this;
    _this.closeCartPopup(selectors);
  },

  /**
   * Update Cart Popup List Item
   *
   */
  updateCartPopup: function(product, price, compareAtPrice, qtyToAdd) {
    if(price && compareAtPrice) {
      if(price < compareAtPrice) {
        var priceString = '<s class="c-price__compare-price">' + slate.Currency.formatMoney(compareAtPrice, theme.moneyFormat) + '</s>' + '<span class="c-price__product-price c-price__product-price--sale">' + slate.Currency.formatMoney(price, theme.moneyFormat) + '</span>';
      } else {
        var priceString = slate.Currency.formatMoney(price, theme.moneyFormat);
      }
    } else {
      var priceString = slate.Currency.formatMoney(product.price, theme.moneyFormat);
    }

    $('[data-cart-popup-items]').html(
      '<li class="c-cart-popup__item">' +
        '<div class="c-cart-popup__item-image-wrap">' +
          (product.image != null ? '<img src="' + product.image + '" alt="' + product.product_title + '">': '') +
        '</div>' +
        '<div class="c-cart-popup__item-content">' +
          '<h3 class="c-cart-popup__item-title">' + product.product_title + '</h3>' +
          '<div class="c-cart-popup__item-qty">Quantity: ' + qtyToAdd + '</div>' +
          '<div class="c-cart-popup__item-properties">' +
            (product.variant_title != null ? product.variant_title + ' <span class="c-cart-popup__item-properties-divider">|</span> ': '') +
            'Price: ' + priceString +
          '</div>' +
        '</div>' +
      '</li>'
    );
  },

  /**
   * Toggle Cart Popup
   *
   */
  toggleCartPopup: function(selectors) {
    var $cartPopup = $('[data-cart-popup]');
    var $cartPopupOverlay = $('[data-cart-popup-overlay]');
    if($cartPopup.hasClass("hide")) {
      $cartPopup.removeClass("hide");
      $cartPopupOverlay.removeClass("hide");
    } else {
      $cartPopup.addClass("hide");
      $cartPopupOverlay.addClass("hide");
    }
  },

  /**
   * Click event for cart popup close icon
   *
   */
  closeCartPopup: function(selectors) {
    $(selectors.cartPopupClose).on('click', function(evt) {
      slate.cart.toggleCartPopup();
    });
  },

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  },


  /**
   * Set Back Url Cookie for use on Product Detail page
   */
  setBackToUrl: function(evt) {
    Cookies.set('back_to_url', window.location.pathname);
  },


  /**
   * Update query string parameters
   */
  updateQueryStringParam: function(key, value) {
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        newParam = key + '=' + value,
        params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var updateRegex = new RegExp('([\?&])' + key + '[^&]*');
      var removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

      if( typeof value == 'undefined' || value == null || value == '' ) { // Remove param if value is empty
        params = urlQueryString.replace(removeRegex, "$1");
        params = params.replace( /[&;]$/, "" );
      } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
        params = urlQueryString.replace(updateRegex, "$1" + newParam);
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }

    // no parameter was set so we don't need the question mark
    params = params == '?' ? '' : params;
    window.history.replaceState({}, "", baseUrl + params);
  },


  /**
   * Update query string parameters
   */
  getQueryStringParam: function(obj) {
    var result = ''
    let match;
    const re = new RegExp('(?:\\?|&)' + obj + '=(.*?)(?=&|$)', 'gi');
    while ((match = re.exec(document.location.search)) !== null) {
      result = match[1];
    }
    return result;
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updateNumber(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantNumberChange
     */
    _updateNumber: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantNumberChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Carousel Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Carousel section.
 *
   * @namespace carousel
 */

theme.Carousel = (function() {

  /**
   * Carousel section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Carousel(container) {
    this.$container = $(container);

    $('[data-carousel]').slick({
      arrows: false,
      dots: true,
      cssEase: 'ease-in-out',
      dotsClass: 'c-carousel__dots',
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false,
      customPaging: function(slider, i) {
        return '<span class="c-carousel__dots-count">' + (i + 1) + '/' + slider.slideCount + '</span><button class="c-carousel__dots-btn">' + (i + 1) + '</button>';
      }
    });

    // $('[data-carousel]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //   $(this).find('.slick-slide[data-slick-index="' + nextSlide + '"]').addClass('is-sliding');
    // });
    //
    // $('[data-carousel]').on('afterChange', function(event, slick, currentSlide, nextSlide){
    //   $(this).find('.slick-slide[data-slick-index="' + currentSlide + '"]').removeClass('is-sliding');
    // });
  }

  Carousel.prototype = $.extend({}, Carousel.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Carousel;
})();

/**
 * Collection Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the collection section.
 *
   * @namespace collection
 */

theme.Collection = (function() {
  function Collection() {
    $(document).ready(function() {

      // Tooltips
      $('[data-tooltip-content]').tooltipster({
        contentCloning: true,
        interactive: true,
        trigger: 'click',
        functionReady: function (instance, helper) {
          $('.tooltipster-close', instance.content()).on('click', function () {
            instance.close()
          })
        }
      })
    })

    Vue.component('product-grid', {
      props: [
        'products',
        'gridView',
        'gridViewFullWidth',
        'listView'
      ],
      template: `
        <div
          class="o-grid"
          :class="{ 'o-grid--productsGrid': gridView, 'o-grid--productsGridFullWidth': gridViewFullWidth, 'o-grid--productsList': listView }">

          <div
            class="o-grid__item"
            v-for="product in products">
              <product-card
                :key="product.node.id"
                :type="product.node.productType"
                :list-view="listView"
                :url="/products/ + product.node.handle"
                :images="product.node.images.edges"
                :title="product.node.title"
                :price="product.node.variants.edges"
                :tags="product.node.tags"
              ></product-card>
          </div>
        </div>
      `,
    })

    Vue.component('product-card', {
      props: [
        'type',
        'listView',
        'url',
        'images',
        'title',
        'price',
        'tags'
      ],
      template: `
        <div
          v-if="url"
          class="c-product-card"
          :class="{ 'c-product-card--list' : listView }">
          <a :href="url" class="c-product-card__inner">
            <div class="c-product-card__image">
              <div class="c-product-card__image-inner">
                <img v-if="images.length > 0" :src="images[0].node.transformedSrc" :alt="title">
                <svg v-else class="c-placeholder" width="100%" height="100%" alt="Default Placeholder"></svg>
              </div>
            </div>
            <div class="c-product-card__primary">
              <h3 v-if="type == 'Propellers'" class="c-product-card__headline">{{ formattedTitle }}</h3>
              <h3 v-else class="c-product-card__headline">{{ title }}</h3>
              <div v-if="dimensions" class="c-product-card__dimensions">{{ dimensions }}</div>
              <div v-if="price[0].node.compareAtPrice" class="c-product-card__price"><span class="c-product-card__price-compare">{{ '$' + formatPrice(price[0].node.compareAtPrice.amount) }}</span> <span class="c-product-card__price-sale">{{ '$' + formatPrice(price[0].node.price.amount) }}</span></div>
              <div v-else class="c-product-card__price">{{ '$' + formatPrice(price[0].node.price.amount) }}</div>
            </div>
            <div v-if="type == 'Propellers'" class="c-product-card__secondary">
              <ul class="c-product-card__specs">
                <li class="c-product-card__spec" v-if="diameter"><span class="c-product-card__spec-label">Diameter:</span> {{ diameter }}</li>
                <li class="c-product-card__spec" v-if="pitch"><span class="c-product-card__spec-label">Pitch:</span> {{ pitch }}</li>
                <li class="c-product-card__spec" v-if="cup"><span class="c-product-card__spec-label">Cup:</span> {{ cup }}</li>
                <li class="c-product-card__spec" v-if="rotation"><span class="c-product-card__spec-label">Rotation:</span> {{ rotation }}</li>
                <li class="c-product-card__spec" v-if="bore"><span class="c-product-card__spec-label">Bore:</span> {{ bore }}</li>
                <li class="c-product-card__spec" v-if="hubLength"><span class="c-product-card__spec-label">Hub:</span> {{ hubLength }}</li>
              </ul>
            </div>
          </a>
        </div>
      `,
      computed: {
        formattedTitle: function() {
          var titleArray = this.title.split(' ')
          return titleArray[0] + ' ' + titleArray[1]
        },
        dimensions: function() {
          var dimensions = this.tags.filter(function(value) {
            return value.includes('Diameter:') || value.includes('Pitch:') || value.includes('Cup:')
          })
          if(dimensions) {
            var sortedDimensions = []
            for(i = 0; i < dimensions.length; i++) {
              if(dimensions[i].includes('Diameter:')) {
                sortedDimensions.splice(0,0,dimensions[i])
              } else if(dimensions[i].includes('Pitch:')) {
                sortedDimensions.splice(1,0,dimensions[i])
              } else if(dimensions[i].includes('Cup:')) {
                sortedDimensions.splice(2,0,dimensions[i])
              }
            }

            if(sortedDimensions) {
              var dimensionsString = ''
              for(i = 0; i < sortedDimensions.length; i++) {
                var specArray = sortedDimensions[i].split(": ")
                if (i != sortedDimensions.length - 1) {
                  dimensionsString += specArray[1] + " x "
                } else {
                  dimensionsString += specArray[1]
                }
              }
              return dimensionsString
            }
          }
        },
        diameter: function() {
          return this.getSpec(this.tags, 'Diameter:')
        },
        pitch: function() {
          return this.getSpec(this.tags, 'Pitch:')
        },
        cup: function() {
          return this.getSpec(this.tags, 'Cup:')
        },
        rotation: function() {
          return this.getSpec(this.tags, 'Rotation:')
        },
        bore: function() {
          return this.getSpec(this.tags, 'Bore:')
        },
        hubLength: function() {
          return this.getSpec(this.tags, 'Hub Length:')
        }
      },
      methods: {
        getSpec: function(array, tagPrefix) {
          var spec = array.filter(function(value) {
            return value.includes(tagPrefix)
          })
          if(typeof spec !== 'undefined') {
            if(spec.length) {
              var specArray = spec[0].split(": ")
              if(specArray[1]) {
                return specArray[1]
              }
            }
          }
        },
        formatPrice(amount) {
          const numericAmount = parseFloat(amount);
          if (!isNaN(numericAmount)) {
            return numericAmount.toFixed(2);
          }
          return "0.00"; // Default value or handle other cases
        },
      }
    })

    new Vue({
      el: '#collection',
      delimiters: ['${', '}'],
      data: {
        products: [],
        tags: [],
        rotations: [
          { label: "L", value: "Left" },
          { label: "R", value: "Right" }
        ],
        bores: [],
        hubLengths: [],
        diameters: [],
        pitches: [],
        cups: [],
        blades: [],
        filters: {
          rotation: {
            label: 'Rotation',
            value: []
          },
          bore: {
            label: 'Bore',
            value: ''
          },
          hubLength: {
            label: 'Hub Length',
            value: ''
          },
          diameter: {
            label: 'Diameter',
            value: []
          },
          pitch: {
            label: 'Pitch',
            value: []
          },
          cup: {
            label: 'Cup',
            value: []
          },
          blades: {
            label: 'Blades',
            value: []
          },
        },
        collapsed: {
          diameters: { value: true },
          pitches: { value: true },
          cups: { value: true },
          blades: { value: true }
        },
        prepopulating: {
          diameters: true,
          pitches: true,
          cups: true,
          blades: true
        },
        loading: true,
        globalPrepopulating: true,
        initialFetch: true,
        gridView: true,
        gridViewFullWidth: false,
        listView: false,
        withFilters: true,
        collectionHandle: '',
        noProductsMessage: false,
        visibleFilterItems: 6,
        showModal: false,
        showFilters: false,
        cursor: null,
        sortBy: 'pitch-desc',
        showAllTagsInCollection: false,
      },
      beforeMount: function() {
        // Detect which collection were in
        var wrapper = document.querySelector('#collection');
        this.collectionHandle = wrapper.dataset.collection;
        if(this.collectionHandle == 'sport' || this.collectionHandle == 'cruiser' || this.collectionHandle == 'products') {
          this.showAllTagsInCollection = true
        }
        this.fetchTags()
      },
      mounted: function() {
        this.initCollection()
      },
      beforeUpdate: function() {
        this.initialFetch = false
      },
      watch: {
        filters: {
          deep: true,
          handler(filters) {
            // console.log(this.initialFetch)
            if(this.globalPrepopulating == false && this.initialFetch == false) {
              this.updateFilters()
            }
            if(this.showFilters) {
              this.toggleFilters()
            }
          }
        }
      },
      computed: {
        currentTags: function() {
          var dataArray = []
          for(var key in this.filters) {
            if(this.filters[key].value.length > 0) {
              if(typeof this.filters[key].value === 'object' &&  this.filters[key].value.length > 0) {
                for(i = 0; i < this.filters[key].value.length; i++) {
                  dataArray.push(this.filters[key].label + ': ' + this.filters[key].value[i])
                }
              } else {
                dataArray.push(this.filters[key].label + ': ' + this.filters[key].value)
              }
            }
          }
          return dataArray
        }
      },
      methods: {
        initCollection: function() {

          // Set some variables based on collection
          if(this.collectionHandle == 'accessories') {
            this.withFilters = false
            this.gridView = false
            this.gridViewFullWidth = true
            this.listView = false
          }

          // Build product query from query string params
          if(slate.utils.getQueryStringParam('rotation')) {
            this.filters.rotation.value = this.convertQueryStringParamToArray(decodeURI(slate.utils.getQueryStringParam('rotation')))
          }
          if(slate.utils.getQueryStringParam('bore')) {
            this.filters.bore.value = decodeURI(slate.utils.getQueryStringParam('bore'))
          }
          if(slate.utils.getQueryStringParam('hubLength')) {
            this.filters.hubLength.value = decodeURI(slate.utils.getQueryStringParam('hubLength'))
          }
          if(slate.utils.getQueryStringParam('diameter')) {
            this.filters.diameter.value = this.convertQueryStringParamToArray(decodeURI(slate.utils.getQueryStringParam('diameter')))
          }
          if(slate.utils.getQueryStringParam('pitch')) {
            this.filters.pitch.value = this.convertQueryStringParamToArray(decodeURI(slate.utils.getQueryStringParam('pitch')))
          }
          if(slate.utils.getQueryStringParam('cup')) {
            this.filters.cup.value = this.convertQueryStringParamToArray(decodeURI(slate.utils.getQueryStringParam('cup')))
          }
          if(slate.utils.getQueryStringParam('blades')) {
            this.filters.blades.value = this.convertQueryStringParamToArray(decodeURI(slate.utils.getQueryStringParam('blades')))
          }

          // Turn off prepopulating flag
          this.globalPrepopulating = false

          // Fetch initial products
          this.fetchProducts()
        },
        fetchTags: function(cursor) {
          // Get tags from script tag outputted in DOM
          const collectionTags = document.getElementById('collection-tags').innerHTML
          this.tags = JSON.parse(collectionTags)

          // Assign values
          this.filterTags()
        },
        fetchProducts: function() {
          this.loading = true
          this.products = []
          this.tags = []

          // if(this.filters.diameter.value.length > 0 || this.diameters.length > 0) {
          //   var fetchingByDiameter = true
          //   var tempProducts = this.productsByDiameter
          // } else {
          //   var fetchingByDiameter = false
          //   var tempProducts = this.products
          // }

          const vm = this
          const token = 'c6ddd08fc0916ead35e8806c11734838'
          const url = 'https://acmemarine.myshopify.com/api/2019-04/graphql.json'
          const variables = {
            orderNum: 250,
            cursor: this.cursor,
            query: vm.buildQueryString()
          }
          const query = `
            query($orderNum: Int!, $cursor: String, $query: String) {
              products(first: $orderNum, after: $cursor, query: $query) {
                edges {
                  cursor
                  node {
                    id
                    handle
                    title
                    tags
                    onlineStoreUrl
                    productType
                    images(first:1) {
                      edges {
                        node {
                          transformedSrc(maxWidth: 400, maxHeight: 400, preferredContentType: PNG)
                        }
                      }
                    }
                    variants(first:1) {
                      edges {
                        node {
                          compareAtPrice {
                            amount
                            currencyCode
                          }
                          price  {
                              amount
                              currencyCode
                          }
                        }
                      }
                    }
                  }
                }
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                }
              }
            }
          `
          $.ajax({
            headers: {
              'X-Shopify-Storefront-Access-Token': token,
              'Content-Type': 'application/json'
            },
            type: 'POST',
            url: url,
            data: JSON.stringify({
              query: query,
              variables: variables
            }),
            success: function(results) {
              const products = results.data.products.edges
              const hasNextPage = results.data.products.pageInfo.hasNextPage
              // const hasNextPage = null

              if(products.length > 0) {
                vm.noProductsMessage = false
                for(var i = 0; i < products.length; i++) {
                  vm.products.push(products[i])
									if(products[i].node.tags.length > 0) {
                    var tags = products[i].node.tags
                    for(var x = 0; x < tags.length; x++) {
                      if(!vm.tags.includes(tags[x])){
                        vm.tags.push(tags[x])
                      }
                    }
                  }
                }

                if(!vm.showAllTagsInCollection) {
                  vm.filterTags()
                }

                if(hasNextPage) {
                  vm.cursor = products[products.length-1].cursor
                } else {
                  vm.cursor = null
                }
              } else {
                vm.noProductsMessage = true
                vm.cursor = null
              }

              vm.showAllTagsInCollection = false
              vm.loading = false
            },
            error: function(errors) {
              console.log(errors)
              vm.loading = false
            }
          })
        },
        switchView(evt) {
          this.loading = true
          value = evt.currentTarget.getAttribute('data-view')
          if(value) {
            if(value == 'grid') {
              if(this.withFilters == false) {
                this.gridView = false
                this.gridViewFullWidth = true
                this.listView = false
              } else {
                this.gridView = true
                this.gridViewFullWidth = false
                this.listView = false
              }
            } else if(value == 'list' && this.listView == false) {
              this.gridView = false
              this.gridViewFullWidth = false
              this.listView = true
            }
          }
          this.loading = false
        },
        formatSpec(spec) {
          if(spec) {
            var specArray = spec.split(": ")
            if(specArray.length > 1) {
              return specArray[1]
            }
          }
        },
        formatSectionTitle(diameter) {
          if(diameter) {
            var diameterArray = diameter.split(": ")
            if(diameterArray.length > 1) {
              return diameterArray[1] + ' ' + diameterArray[0]
            }
          }
        },
        resetFilters() {
          window.location.href = [location.protocol, '//', location.host, location.pathname].join('')
        },
        updateFilters() {
          for(var key in this.filters) {
            if(this.filters[key].value) {
              slate.utils.updateQueryStringParam(key, this.filters[key].value)
            } else {
              slate.utils.updateQueryStringParam(key, '')
            }
          }

          // Fetch new products
          this.fetchProducts()
        },
        filterTags() {
          // Assign tags to specific variables
          this.bores = _.filter(this.tags, function(item) {
            return item.includes('Bore:')
          })
          this.hubLengths = _.filter(this.tags, function(item) {
            return item.includes('Hub Length:')
          })
          if(this.prepopulating.diameters || this.filters.diameter.value.length == 0) {
            this.diameters = _.filter(this.tags, function(item) {
              return item.includes('Diameter:')
            })
            // console.log(this.diameters)
            this.diameters = this.sortArray(this.diameters, 'asc')
            this.prepopulating.diameters = false
          }
          if(this.prepopulating.pitches || this.filters.pitch.value.length == 0) {
            this.pitches = _.filter(this.tags, function(item) {
              return item.includes('Pitch:')
            })
            this.prepopulating.pitches = false
          }
          if(this.prepopulating.cups || this.filters.cup.value.length == 0) {
            this.cups = _.filter(this.tags, function(item) {
              return item.includes('Cup:')
            })
            this.prepopulating.cups = false
          }
          if(this.prepopulating.blades || this.filters.blades.value.length == 0) {
            this.blades = _.filter(this.tags, function(item) {
              return item.includes('Blades:')
            })
            this.prepopulating.blades = false
          }
        },
        removeFilter(tag) {
          if(tag) {
            var tagArray = tag.split(': ')
            for(var key in this.filters) {
              if(this.filters[key].label == tagArray[0]) {
                if(typeof this.filters[key].value == 'object') {
                  var index = this.filters[key].value.indexOf(tagArray[1])
                  if(index > -1) {
                    this.filters[key].value.splice(index, 1)
                  }
                } else {
                  this.filters[key].value = ''
                }
              }
            }
          }
        },
        buildQueryString(fetchingByDiameter, diameter) {
          var queryString = ''

          if(this.collectionHandle == 'wake-ski' || this.collectionHandle == 'sport') {
            queryString += 'tag:Wake/Ski '
          } else if(this.collectionHandle == 'cruiser') {
            queryString += 'tag:Cruiser '
          } else if(this.collectionHandle == 'accessories') {
            queryString += 'tag:Accessories '
          }

          for(var key in this.filters) {
            if(this.filters[key].value) {
              if(this.filters[key].value.constructor === Array) {
                for(i = 0; i < this.filters[key].value.length; i++) {
                  if (i != this.filters[key].value.length - 1) {
                    queryString += "tag:'" + this.filters[key].label + ": " + this.filters[key].value[i] + "' OR "
                  } else {
                    queryString += "tag:'" + this.filters[key].label + ": " + this.filters[key].value[i] + "' "
                  }
                }
              } else {
                queryString += "tag:'" + this.filters[key].label + ": " + this.filters[key].value + "' "
              }
            }
          }

          // console.log(queryString)
          return queryString
        },
        convertQueryStringParamToArray(string) {
          var dataArray = []
          if(string.includes(',')) {
            var tempArray = string.split(',')
            for(i = 0; i < tempArray.length; i++) {
              dataArray.push(tempArray[i])
            }
          } else {
            dataArray.push(string)
          }
          return dataArray
        },
        toggleList(evt, filter) {
          if(filter.value) {
            filter.value = false
            evt.currentTarget.innerHTML = '- Show Less'
          } else {
            filter.value = true
            evt.currentTarget.innerHTML = '+ Show More'
          }
        },
        sortArray(array, direction, value) {
          return _.orderBy(array, value, direction)
        },
        productsByDiameter(diameter) {
          // Get all products by diameter
          filteredProducts = _.filter(this.products, function(item) {
            return item.node.tags.includes(diameter)
          })

          // Sort products by declared value
          const sortByArray = this.sortBy.split('-')
          const sortByValue = sortByArray[0].charAt(0).toUpperCase() + sortByArray[0].slice(1)
          const sortByDirection = sortByArray[1]

          filteredProducts.sort(function(a,b) {
            aValue = _.filter(a.node.tags, function(tag) {
              return tag.includes(sortByValue + ': ')
            })

            bValue = _.filter(b.node.tags, function(tag) {
              return tag.includes(sortByValue + ': ')
            })

            if(aValue < bValue) {
              if(sortByDirection == 'desc') {
                return 1
              } else {
                return -1
              }
            }
            if(aValue > bValue) {
              if(sortByDirection == 'desc') {
                return -1
              } else {
                return 1
              }
            }
            return 0
          })

          return filteredProducts
        },
        toggleModal() {
          if(this.showModal) {
            this.showModal = false
          } else {
            this.showModal = true
          }
        },
        toggleFilters() {
          if(this.showFilters) {
            this.showFilters = false
          } else {
            this.showFilters = true
          }
        }
      }
    })
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace)
    }
  })

  return Collection
})()

/**
 * Finer Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Finer section.
 *
   * @namespace finder
 */

theme.Finder = (function() {

  /**
   * Finder section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Finder(container) {
    this.$container = $(container);
    $(selectors.dealerListing).on('mouseenter mouseleave', this.toggleDealerListing.bind(this));
  }

  Finder.prototype = $.extend({}, Finder.prototype, {

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Finder;
})();

/**
 * Header Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Header template.
 *
   * @namespace header
 */

theme.Header = (function() {

  var selectors = {
    siteNav: '[data-site-nav]',
    sitePrenav: '[data-site-prenav]',
    navSearch: '[data-nav-search]',
    navSearchInput: '[data-nav-search-input]',
    megamenu: '[data-megamenu]',
    submenu: '[data-submenu]',
    shopSpecs: '[data-shop-specs]',
    toggleMegamenu: '[data-toggle-megamenu]',
    toggleShopSpecs: '[data-toggle-shop-specs]',
    toggleSearch: '[data-nav-search-toggle]',
    toggleMobileNav: '[data-toggle-mobile-nav]',
    toggleMobileNavSubmenu: '[data-toggle-submenu]',
    toggleMobileNavShopSpecs: '[data-toggle-mobile-shop-specs]',
    mobileNav: '[data-mobile-nav]',
    mobileNavSearch: '[data-mobile-nav-search]',
    mobileNavSearchInput: '[data-mobile-nav-search-input]',
    toggleMobileSearch: '[data-mobile-nav-search-toggle]',
  };

  /**
   * Header section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Header(container) {
    this.$container = $(container);

    var sectionId = this.$container.attr('data-section-id');

    $(selectors.toggleMegamenu).on('click', this.toggleMegamenu.bind(this));
    $(selectors.toggleShopSpecs).on('click', this.toggleShopSpecs.bind(this));
    $(selectors.toggleMobileNav).on('click', this.toggleMobileNav.bind(this));
    $(selectors.toggleMobileNavSubmenu).on('click', this.toggleMobileNavSubmenu.bind(this));
    $(selectors.toggleMobileNavShopSpecs).on('click', this.toggleMobileNavShopSpecs.bind(this));
    $(selectors.toggleSearch).on('click', this.toggleNavSearch.bind(this));
    $(selectors.toggleMobileSearch).on('click', this.toggleMobileNavSearch.bind(this));
    $(window).on('click', this.toggleAllMenus.bind(this));

    // Resize Shop Specs
    $(window).resize(this.resizeShopSpecs);

    // Stick nav to top
    var sticky = new Waypoint.Sticky({
      element: $(selectors.siteNav)[0],
      handler: this.resizeMobileNav
    })
  }

  Header.prototype = $.extend({}, Header.prototype, {

    /**
     * Toggles megamenu
     *
     */
    toggleMegamenu: function(evt) {
      var $body = $('body')
      var $toggle = $(evt.currentTarget)
      var $megamenu = $(evt.currentTarget).siblings(selectors.megamenu)
      var $shopSpecs = $(evt.currentTarget).find(selectors.shopSpecs)

      if($megamenu.hasClass('is-open')) {
        sameToggle = true
      } else {
        var sameToggle = false
      }

      // Close all megamenus & shopspecs
      $(selectors.toggleMegamenu).removeClass('is-active')
      $(selectors.megamenu).removeClass('is-open')
      $(selectors.toggleShopSpecs).removeClass('is-active')
      $(selectors.shopspecs).removeClass('is-open')

      // Open New if it wasn't already selected
      if(!sameToggle) {
        $body.addClass('body-overlay')
        $toggle.addClass('is-active')
        $megamenu.addClass('is-open')
      } else {
        $body.removeClass('body-overlay')
      }
    },

    /**
     * Toggles shop specs
     *
     */
    toggleShopSpecs: function(evt) {
      var $toggle = $(evt.currentTarget)
      var $shopSpecs = $(evt.currentTarget).siblings(selectors.shopSpecs)
      if($shopSpecs.hasClass('is-open')) {
        $toggle.removeClass('is-active')
        $shopSpecs.removeClass('is-open')
      } else {
        $toggle.addClass('is-active')
        $shopSpecs.addClass('is-open')
        if($shopSpecs.attr('id').indexOf("mobile") <= 0) {
          this.resizeShopSpecs(evt, $shopSpecs)
        }
      }
    },

    /**
     * Toggles search form in nav
     *
     */
    toggleNavSearch: function(evt) {
      var $navSearch = $(selectors.navSearch);
      var $navSearchInput = $(selectors.navSearchInput);
      console.log($navSearchInput)
      if($navSearch.hasClass('is-open')) {
        $navSearch.removeClass('is-open');
      } else {
        $navSearch.addClass('is-open');
        window.setTimeout(function() {
          $navSearchInput.focus();
        }, 500);
      }
    },

    /**
     * Toggles search form in mobile nav
     *
     */
    toggleMobileNavSearch: function(evt) {
      var $parent = $(evt.currentTarget).parent(selectors.mobileNavSearch);
      var $navSearch = $(selectors.mobileNavSearch);
      var $navSearchInput = $('input', $parent);
      if($navSearch.hasClass('is-open')) {
        $navSearch.removeClass('is-open');
      } else {
        $navSearch.addClass('is-open');
        window.setTimeout(function() {
          $navSearchInput.focus();
        }, 500);
      }
    },

    /**
     * Toggles mobile nav
     *
     */
    toggleMobileNav: function(evt) {
      var $body = $('body');
      var $mobileNav = $(selectors.mobileNav);
      var $siteNav = $(selectors.siteNav);
      var $sitePrenav = $(selectors.sitePrenav);
      if($body.hasClass('nav-is-open')) {
        $body.removeClass('nav-is-open');
      } else {
        $body.addClass('nav-is-open');
      }
    },


    /**
     * Toggles mobile nav submenus
     *
     */
    toggleMobileNavSubmenu: function(evt) {
      var $toggle = $(evt.currentTarget)
      var $submenu = $(evt.currentTarget).siblings(selectors.submenu)
      var $shopSpecs = $(evt.currentTarget).find(selectors.shopSpecs)

      if($submenu.hasClass('is-open')) {
        sameToggle = true
      } else {
        var sameToggle = false
      }

      // Close all submenus & shopspecs
      $(selectors.toggleMobileNavSubmenu).removeClass('is-active')
      $(selectors.submenu).removeClass('is-open')
      $(selectors.shopspecs).removeClass('is-open')

      // Open New if it wasn't already selected
      if(!sameToggle) {
        $toggle.addClass('is-active')
        $submenu.addClass('is-open')
      }
    },


    /**
     * Toggles mobile nav shop specs
     *
     */
    toggleMobileNavShopSpecs: function(evt) {
      var $toggle = $(evt.currentTarget)
      var $shopSpecs = $(evt.currentTarget).siblings(selectors.shopSpecs)

      if($shopSpecs.hasClass('is-open')) {
        $toggle.removeClass('is-active')
        $shopSpecs.removeClass('is-open')
      } else {
        $toggle.addClass('is-active')
        $shopSpecs.addClass('is-open')
      }
    },


    /**
     * Resize shop specs
     *
     */
    resizeShopSpecs: function(evt, shopSpecs) {
      // Find shop specs
      if(!shopSpecs) {
        if($(selectors.shopSpecs).hasClass('is-open')) {
          var $shopSpecs = $('.c-shop-specs.is-open')
        } else {
          return
        }
      } else {
        var $shopSpecs = shopSpecs
      }

      // Let's bounce if no open shop specs
      if(!$shopSpecs) {
        return
      }

      console.log($shopSpecs)

      // Resize shop specs
      var windowHeight = $(window).height()

      if(windowHeight <= 650) {
        var $siteNav = $(selectors.siteNav)
        var $sitePrenav = $(selectors.sitePrenav)
        var $megamenu = $(selectors.megamenu)

        if($siteNav.hasClass('stuck') == true) {
          $shopSpecs.css('height', ($(window).height() - $siteNav.outerHeight() - $megamenu.outerHeight()))
        } else {
          $shopSpecs.css('height', ($(window).height() - $siteNav.outerHeight() - $sitePrenav.outerHeight() - $megamenu.outerHeight()))
        }
      } else {
        $shopSpecs.css('height', 'auto')
      }
    },


    /**
     * Close all menus when background is clicked
     *
     */
    toggleAllMenus: function(evt) {
      var container = $('.c-site-header');
      if(!container.is(evt.target) && container.has(evt.target).length === 0) {
        $('body').removeClass('body-overlay');
        $('.c-site-nav__link').removeClass('is-active');
        $(selectors.megamenu).removeClass('is-open');
        $(selectors.shopSpecs).removeClass('is-open');
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Header;
})();

/**
 * Instagram Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Instagram section.
 *
   * @namespace instagram
 */

theme.Instagram = (function() {

  /**
   * Instagram section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Instagram(container) {
    this.$container = $(container);

    var feed = new Instafeed({
      get: 'user',
      userId: '5639414229',
      limit: 8,
      resolution: 'standard_resolution',
      template: '<div class="o-grid__item u-width-6-of-12--small-up u-width-3-of-12--medium-up"><a href="{{link}}" target="_blank" class="o-ratio o-ratio--instagram"><img class="{{orientation}}" src="{{image}}" alt="{{caption}}" /></a></div>',
      accessToken:""// InstagramToken
    });
    feed.run();

  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Instagram;
})();

/**
 * DealerLocator Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the DealerLocator section.
 *
   * @namespace dealerLocator
 */

theme.DealerLocator = (function() {

  var selectors = {
    dealerLocations: '[data-dealer-locations]',
    dealerListings: '[data-dealer-listings]',
    dealerListing: '[data-dealer-listing]',
    dealerListingDistanceEl: '[data-dealer-listing-distance-el]',
    dealerButton: '[data-dealer-button]',
    dealerLoader: '[data-dealer-loader]',
    dealerSearch: 'dealer-locator-search'
  };

  var $dealerLoader = $(selectors.dealerLoader);
  var $dealerSearch = $(selectors.dealerSearch);
  var markers = [];
  var searchAreaMarkers = [];
  var searchAreas = [];
  var map;
  var initialLocation = { lat: 43.7039553, lng: -85.4676156 };
  var locations;

  /**
   * DealerLocator section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function DealerLocator(container) {
    this.$container = $(container);

    // Get locations object offsite
    this.getLocations();

    // Stop form from submitting on enter
    $(container).keydown(function(evt) {
      if(evt.keyCode == 13) {
        evt.preventDefault();
        return false;
      }
    });
  }

  DealerLocator.prototype = $.extend({}, DealerLocator.prototype, {

    /**
     * Get all markers for map
     */
    getLocations: function() {
      _self = this;

      $.ajax( {
        url: 'https://acmemarine.com/apps/dealers/dealer-locations.json',
        dataType: 'json',
        success: success,
        error: function(response) {
          console.log(response);
          _self.initMap();
        }
      });

      function success(response) {
        locations = response;
        $('body').attr('data-locations', locations.length);
        _self.initMap();
      }
    },

    /**
     * Initialize Dealer DealerLocator Map
     */
    initMap: function(evt) {

      // Show Loader
      $dealerLoader.addClass('is-visible');

      // Initialize Map
      map = new google.maps.Map(document.getElementById('map'), {
        center: initialLocation,
        zoom: 3,
        styles: [
          {
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "elementType": "labels.text.stroke",
            "stylers": [
              {
                "color": "#f5f5f5"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#bdbdbd"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "poi.business",
            "elementType": "labels.icon",
            "stylers": [
              {
                "color": "#ffeb3b"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#ffffff"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#757575"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#dadada"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#616161"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#e5e5e5"
              }
            ]
          },
          {
            "featureType": "transit.station",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#eeeeee"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
              {
                "color": "#c9c9c9"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#9e9e9e"
              }
            ]
          }
        ]
      });

      // Get all markers to map
      this.getMarkers();

      // Get user location
      this.getUserLocation();

      // Add listener when autocomplete changes
      var input = document.getElementById('dealer-locator-search');
      var options = {
        types: ['(cities)']
      };
      var autocomplete = new google.maps.places.Autocomplete(input, options);

      _self = this;
      google.maps.event.addListener(autocomplete, 'place_changed', function() {
        var place = autocomplete.getPlace();
        if (!place.geometry) {
          // User entered the name of a Place that was not suggested and
          // pressed the Enter key, or the Place Details request failed.
          window.alert("Please enter a City/State");
          return;
        } else {
          for (var ac = 0; ac < place.address_components.length; ac++) {
            var component = place.address_components[ac];
            switch(component.types[0]) {
              case 'locality':
                var city = component.long_name;
                break;
              case 'administrative_area_level_1':
                var state = component.short_name;
                break;
            }
          }
        }
        _self.updateMap(place.geometry.location.lat(), place.geometry.location.lng(), city, state);
      });
    },


    /**
     * Get all markers for map
     */
    getMarkers: function() {
      var bounds = new google.maps.LatLngBounds();
      var icon = {
        url: "https://cdn.shopify.com/s/files/1/2460/1219/files/marker.png?8551695039329886284",
        scaledSize: new google.maps.Size(16, 22),
        origin: new google.maps.Point(0,0),
        anchor: new google.maps.Point(0, 22)
      };

      for (var i = 0; i < locations.length; i++) {
        // Add marker to map
        var markerLatLng = new google.maps.LatLng(locations[i]['latitude'], locations[i]['longitude']);
        var marker = new google.maps.Marker({
          position: markerLatLng,
          icon: icon,
          title: locations[i]['name'],
          id: locations[i]['id'],
          street_1: locations[i]['address_street_1'],
          street_2: locations[i]['address_street_2'],
          city: locations[i]['address_city'],
          state: locations[i]['address_state'],
          zip: locations[i]['address_zip'],
          phone: locations[i]['phone'],
          email: locations[i]['email'] ? locations[i]['email'] : ''
        });

        // Keep marker instances in a global array
        markers.push(marker);

        marker.setMap(map);

        // Add click event for info window
        google.maps.event.addListener(marker, 'click', (function(marker, i) {
          return function() {
            // Toggle Dealer Listing First and then scroll to position
            _self.toggleDealerListing(marker.id);
          }
        })(marker, i));
    }
    },


    /**
     * Update markers within search radius
     */
    updateMap: function(latitude, longitude, city, state) {
      _self = this;

      // Set search state
      this.updateDealerSearch(city, state);

      // Clear old search markers and search areas
      this.clearSearchAreaMarkers();
      this.clearSearchAreas();

      // Clear old dealerlistings
      $(selectors.dealerListings).empty();

      // Set search radius and find markers if we have a latitude & longitude
      if(latitude && longitude) {
        // Setup variables
        var bounds = new google.maps.LatLngBounds();
        var searchAreaCenter = new google.maps.LatLng(latitude, longitude);
        var searchAreaRadius = 100 * 1609.34; // Conver miles to meters

        var icon = {
          url: "https://cdn.shopify.com/s/files/1/2460/1219/files/marker-user.png?8551695039329886284",
          scaledSize: new google.maps.Size(16, 22),
          origin: new google.maps.Point(0,0),
          anchor: new google.maps.Point(0, 22)
        };

        // Then add the new one
        var searchArea = new google.maps.Circle({
          strokeColor: '#FF0000',
          strokeOpacity: 0,
          strokeWeight: 2,
          fillColor: '#FF0000',
          fillOpacity: 0,
          map: map,
          center: searchAreaCenter,
          radius: searchAreaRadius
        });
        searchAreas.push(searchArea);

        // Then add the new one
        var searchAreaMarker = new google.maps.Marker({
          position: searchAreaCenter,
          map: map,
          icon: icon,
          animation: google.maps.Animation.DROP,
          title: 'Your Current Location'
        });
        searchAreaMarkers.push(searchAreaMarker);

        for (var i = 0; i < markers.length; i++) {
          var marker = markers[i];
          var distanceInMeters = google.maps.geometry.spherical.computeDistanceBetween(searchArea.getCenter(), marker.getPosition());
          var distanceInMiles = (distanceInMeters * 0.000621371).toFixed(1); // convert meters to miles

          if (distanceInMeters <= searchArea.getRadius()) {
            marker.setMap(map);
            bounds.extend(marker.getPosition());
            this.addDealerListing(marker, distanceInMiles);
          } else {
            marker.setMap(null);
          }
        }

        // Sort dealer listings
        $(selectors.dealerListing).sort(this.sortListings).appendTo(selectors.dealerListings);

        // Click function to toggle listings
        $(selectors.dealerListing).on('click', this.clickDealerListing.bind(this));

        // Set the center of the map
        map.panTo(searchAreaMarker.getPosition());
        map.setZoom(7.5);
      } else {
        // Set the center of the map
        latLng = new google.maps.LatLng(initialLocation.lat,initialLocation.lng);
        map.setCenter(latLng);
        map.setZoom(3);
      }

      // Hide Loader
      $dealerLoader.removeClass('is-visible');
    },


    /**
     * Append dealer listing to list
     */
    addDealerListing: function(location, distance) {
      $(selectors.dealerListings).append(
        '<li class="c-dealer-locator__item" data-dealer-listing="' + location.id + '" data-dealer-listing-distance="' + distance + '">' +
          '<div class="c-dealer-locator__item-location">' +
            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-marker" viewBox="0 0 18 24"><g fill="currentColor" fill-rule="nonzero"><path d="M12.5 9a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm-1 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"></path><path d="M.5 9.043C.5 4.326 4.306.5 9 .5c4.695 0 8.5 3.825 8.5 8.543 0 3.233-1.543 6.608-4.104 9.941a33.49 33.49 0 0 1-3.713 4.075c-.169.155-.29.263-.357.32a.5.5 0 0 1-.652 0 14.866 14.866 0 0 1-.357-.32 33.49 33.49 0 0 1-3.714-4.075C2.044 15.651.5 12.276.5 9.043zm9.395 12.42a32.5 32.5 0 0 0 2.709-3.088C15.043 15.2 16.5 12.012 16.5 9.043 16.5 4.876 13.142 1.5 9 1.5c-4.14 0-7.5 3.377-7.5 7.543 0 2.969 1.457 6.157 3.896 9.332a32.5 32.5 0 0 0 3.6 3.948c.277-.247.577-.535.9-.86z"></path></g></svg>' +
            '<span data-dealer-listing-distance-el>' + distance + ' mi</span>'+
          '</div>' +
          '<div class="c-dealer-locator__item-details">' +
            '<h2 class="c-dealer-locator__item-name">' + location.title + '</h2>' +
            '<address class="c-dealer-locator__item-address">' +
              location.street_1 + '<br>' +
              location.city + ', ' + location.state + ' ' + location.zip + '<br>' +
              location.phone + '<br>' + location.email +
            '</address>' +
          '</div>' +
          '<div class="c-dealer-locator__item-btn" data-dealer-button>' +
            '<a href="tel:' + location.phone +'" class="c-btn c-btn--white c-btn--full">Call Now</a>' +
          '</div>' +
        '</li>'
      );
    },


    /**
     * Clear Seach Area Markers
     */
    clearSearchAreaMarkers: function() {
      for (var i = 0; i < searchAreaMarkers.length; i++) {
        searchAreaMarkers[i].setMap(null);
      }
      searchAreaMarkers.length = 0;
    },


    /**
     * Clear Seach Area Markers
     */
    clearSearchAreas: function() {
      for (var i = 0; i < searchAreas.length; i++) {
        searchAreas[i].setMap(null);
      }
      searchAreas.length = 0;
    },


    /**
     * Update Dealer Search
     */
    updateDealerSearch: function(city, state) {
      var $dealerSearch = $('#' + selectors.dealerSearch);
      if(city != null && state != null) {
        $dealerSearch.val(city + ', ' + state);
      } else {
        $dealerSearch.val('').focus();
      }
    },


    /**
     * Get user's location
     */
    getUserLocation: function() {
      var _self = this;

      function getAddress(position) {
        var latitude = position.coords.latitude;
    		var longitude = position.coords.longitude;

        $.ajax( {
          url: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDwNz-a4mRPJewiY642xDA1WAuWHVIAHMQ&latlng=' + latitude + ',' + longitude + '&sensor=true',
          dataType: 'json',
          success: function(response) {
            var results = response.results;
            let storableLocation = {};
            for (var ac = 0; ac < results[0].address_components.length; ac++) {
              var component = results[0].address_components[ac];
              if (component.types.includes('sublocality') || component.types.includes('locality')) {
                storableLocation.city = component.long_name;
              } else if (component.types.includes('administrative_area_level_1')) {
                storableLocation.state = component.short_name;
              } else if (component.types.includes('country')) {
                storableLocation.country = component.long_name;
                storableLocation.registered_country_iso_code = component.short_name;
              }
            }
            Cookies.set('locator_latitude', latitude, { expires: 1 });
            Cookies.set('locator_longitude', longitude, { expires: 1 });
            Cookies.set('locator_city', storableLocation.city, { expires: 1 });
            Cookies.set('locator_state', storableLocation.state, { expires: 1 });
            _self.updateMap(latitude, longitude, storableLocation.city, storableLocation.state);
          },
          error: function(response) {
            console.log(response);
            _self.updateMap();
          }
        });
      }

      function getPositionBy3rdParty() {
        $.getJSON('https://ipinfo.io/geo', function(response) {
          var loc = response.loc.split(',');
          var position = {
            "coords": {
              latitude: loc[0],
              longitude: loc[1]
            }
          };
          getAddress(position);
        });
      }

      // Check if we have the user's location stored
      // If not, let's grab it.
      if(Cookies.get('locator_latitude') && Cookies.get('locator_longitude') && Cookies.get('locator_city') && Cookies.get('locator_state')) {
        _self.updateMap(Cookies.get('locator_latitude'), Cookies.get('locator_longitude'), Cookies.get('locator_city'), Cookies.get('locator_state'));
      } else {
        // Check if browser supports
  			if(navigator.geolocation) {
          // if geolocation supported, call function
          var options = {
            enableHighAccuracy: false,
            timeout: 5000,
            maximumAge: 0
          };
  				navigator.geolocation.getCurrentPosition(getAddress, getPositionBy3rdParty, options);
  			} else {
          _self.updateMap();
  			}
      }

    },

    /**
     * Sort Dealer listings by data-dealer-listing-distance
     */
    sortListings: function(a, b) {
      var an = a.getAttribute('data-dealer-listing-distance');
      var bn = b.getAttribute('data-dealer-listing-distance');

    	if(an > bn) {
    		return 1;
    	}
    	if(an < bn) {
    		return -1;
    	}
    	return 0;
    },

    /**
     * Click function for dealer listings
     */
    clickDealerListing: function(evt) {
      var id = evt.currentTarget.attributes['data-dealer-listing'].value;
      var $dealerListing = $('[data-dealer-listing="' + id + '"]');
      var $dealerListingBtn = $(selectors.dealerButton, $dealerListing);

      // Remove all open classes and close buttons
      $(selectors.dealerListing).removeClass('is-open');
      $(selectors.dealerButton).slideUp('fast');

      // Find the selected listing and toggle it
      if ($dealerListing.hasClass('is-open')) {
        $dealerListing.removeClass('is-open');
        $dealerListingBtn.slideUp('fast');
      } else {
        $dealerListing.addClass('is-open');
        $dealerListingBtn.slideDown('fast');
      }
    },


    /**
     * Toggle function for dealer listings
     */
    toggleDealerListing: function(id) {
      var $dealerListing = $('[data-dealer-listing="' + id + '"]');
      var $dealerListingBtn = $(selectors.dealerButton, $dealerListing);

      // Remove all open classes and close buttons
      $(selectors.dealerListing).removeClass('is-open');
      $(selectors.dealerButton).slideUp('fast');

      // Find the selected listing and toggle it
      _self = this;
      if ($dealerListing.hasClass('is-open')) {
        $dealerListing.removeClass('is-open');
        $dealerListingBtn.slideUp('fast', function() {
          _self.scrollToDealerListing(id);
        });
      } else {
        $dealerListing.addClass('is-open');
        $dealerListingBtn.slideDown('fast', function() {
          _self.scrollToDealerListing(id);
        });
      }
    },

    /**
     * Scroll To Dealer Listing
     */
    scrollToDealerListing: function(id) {
      // ScrollTo
      jQuery.fn.scrollTo = function(elem, speed) {
        $(this).animate({
          scrollTop:  $(this).scrollTop() - $(this).offset().top + $(elem).offset().top
        }, speed == undefined ? 700 : speed);
        return this;
      };

      // Scroll to the element in the list
      $(selectors.dealerListings).scrollTo('[data-dealer-listing="' + id + '"]');
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return DealerLocator;
})();

/**
 * Partners Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Partners section.
 *
   * @namespace partners
 */

theme.Partners = (function() {

  /**
   * Partners section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Partners(container) {
    this.$container = $(container);

    $('[data-partners]').slick({
      arrows: true,
      dots: true,
      nextArrow: '<button class="slick-arrow slick-next"><span class="u-hide-visually">Next</span></button>',
      prevArrow: '<button class="slick-arrow slick-prev"><span class="u-hide-visually">Previous</span></button>',
    });

    // $('[data-partners]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    //   $(this).find('.slick-slide[data-slick-index="' + nextSlide + '"]').addClass('is-sliding');
    // });
    //
    // $('[data-partners]').on('afterChange', function(event, slick, currentSlide, nextSlide){
    //   $(this).find('.slick-slide[data-slick-index="' + currentSlide + '"]').removeClass('is-sliding');
    // });
  }

  Partners.prototype = $.extend({}, Partners.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Partners;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartForm: '[data-add-to-cart-form]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productNumber: '[data-product-number]',
    productPrice: '[data-product-price]',
    productPriceLabel: '[data-product-price-label]',
    productQtyToAdd: '[data-product-qty]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    triggerModal: '[data-trigger-modal]',
    closeModal: '[data-close-modal]',
    modal: '#modal',
    backToLink: '[data-back-to-link]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantNumberChange' + this.namespace, this.updateProductNumber.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    $(selectors.productThumbs).on('click' + this.namespace, this.toggleProductImage.bind(this));
    $(selectors.triggerModal).on("click", this.toggleModal.bind(this));
    $(selectors.closeModal).on("click", this.toggleModal.bind(this));
    $(window).on("click", this.windowOnClick.bind(this));
    $(selectors.addToCart, this.$container).on('click', this.addToCart.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    if(Cookies.get('back_to_url')) {
      $(selectors.backToLink).attr('href', Cookies.get('back_to_url'));
    }

  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Add items to cart via ajax
     *
     */
    addToCart: function(evt) {
      evt.preventDefault();
      var qtyToAdd = $(selectors.productQtyToAdd).val();
      var product = this.productSingleObject;
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(selectors.addToCartForm).serialize(),
        dataType: 'json',
        success: function(response) {
          slate.cart.updateCartPopup(response, product.price, product.compare_at_price, qtyToAdd);
          slate.cart.toggleCartPopup();
        },
        error: function(XMLHttpRequest) {
          console.log(XMLHttpRequest);
        }
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified sku
     *
     * @param {string} productNumber - The current sku of the product
     */
    updateProductNumber: function(evt) {
      var variant = evt.variant;
      var $productNumber = $(selectors.productNumber, this.$container);

      if (variant.sku) {
        $productNumber.html(variant.sku);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var $productPrice = $(selectors.productPrice, this.$container);
      var $productPriceLabel = $(selectors.productPriceLabel, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $productPrice.addClass('c-price__product-price--sale');
        $productPriceLabel.removeClass('hide');
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $productPrice.removeClass('c-price__product-price--sale');
        $productPriceLabel.addClass('hide');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      evt.preventDefault();
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Toggle Feature image by click of thumbnail
     *
     * @param {string} src - Image src URL
     */
    toggleProductImage: function(evt) {
      evt.preventDefault();
      var sizedImgUrl = evt.currentTarget.href;

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Toggle Dealer Locator Modal
     *
     */
    toggleModal: function(evt) {
      var $modal = $(selectors.modal);
      $modal.toggleClass('is-visible');
    },

    /**
     * Toggle Dealer Locator Modal
     *
     */
    windowOnClick: function(evt) {
      var modal = document.getElementById('modal');
      if (event.target === modal) {
        this.toggleModal();
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

/**
 * PropFinder Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the PropFinder section.
 *
   * @namespace propFinder
 */

theme.PropFinder = (function() {
  function PropFinder() {
    $(document).ready(function() {
      $('[data-tooltip-content]').tooltipster({
        contentCloning: true,
        interactive: true,
        trigger: 'click',
        functionReady: function (instance, helper) {
          $('.tooltipster-close', instance.content()).on('click', function () {
            instance.close()
          })
        }
      })
    })

    var _standardProp = 3
    var _totalProps = 7
    var allYears
    var allModels
    var _gaugeData = {
      wake: [
        {
          label: 'SM',
          name: 'Smooth',
          info: 'Skiing/cruising',
          modifier: -1
        },
        {
          label: 'AVG',
          name: 'Average',
          info: 'All-purpose',
          modifier: 0
        },
        {
          label: 'LG',
          name: 'Large',
          info: 'Wakeboarding/surfing',
          modifier: 1
        }
      ],
      weight: [
        {
          label: '0-2K',
          name: 'Light',
          info: '0,000-2,000 LBS',
          modifier: -1
        },
        {
          label: '2-4K',
          name: 'Moderate',
          info: '2,000-4,000 LBS',
          modifier: 0
        },
        {
          label: '4-6K',
          name: 'Heavy',
          info: '4,000-6,000 LBS',
          modifier: 1
        }
      ],
      elevation: [
        {
          label: '0-3K',
          name: 'Low',
          info: 'Sea Level-3,000 FT',
          modifier: 0
        },
        {
          label: '3-6K',
          name: 'Moderate',
          info: '3,000-6,000 FT',
          modifier: 1
        },
        {
          label: '6-9K',
          name: 'High',
          info: '6,000-9,000 FT',
          modifier: 2
        }
      ]
    }

    new Vue({
      el: '#app',
      delimiters: ['${', '}'],
      data: {
        boatOptions: [],
        props: {
          1: '----',
          2: '----',
          3: '----',
          4: '----',
          5: '----',
          6: '----',
          7: '----'
        },
        makes: [],
        models: [],
        years: [],
        make: '',
        model: '',
        year: '',
        userProp: '',
        gaugeData: _gaugeData,
        gaugesActive: false,
        highlightProp: 0,
        wakeOptionChecked: null,
        weightOptionChecked: null,
        elevationOptionChecked: null,
        selectionResult: [],
        loading: true,
        prePopulating: true,
        showModal: false
      },
      mounted: function() {
        this.fetchBoatSpecs()
      },
      watch: {
        make: function(value) {
          this.updateMake(value)
        },
        year: function() {
          this.updateYear()
        },
        model: function() {
          this.updateModel()
        },
        userProp: function() {
          this.updateUserProp()
        },
        wakeOptionChecked: function() {
          this.updateHighlightProp()
        },
        weightOptionChecked: function() {
          this.updateHighlightProp()
        },
        elevationOptionChecked: function() {
          this.updateHighlightProp()
        }
      },
      methods: {
        fetchBoatSpecs: function() {
          var vm = this
          axios
            .get('https://phpstack-1358971-4999781.cloudwaysapps.com/api.json')
            .then(function(response) {
              vm.boatOptions = response.data.data
              vm.makes = _.uniqBy(vm.boatOptions, 'make')
              vm.loading = false
              // If we have cookies, let's prepopulate the data
              vm.make = Cookies.get('prop_finder_make') ? Cookies.get('prop_finder_make') : ''
              vm.model = Cookies.get('prop_finder_model') ? Cookies.get('prop_finder_model') : ''
              vm.year = Cookies.get('prop_finder_year') ? Cookies.get('prop_finder_year') : ''
              vm.userProp = Cookies.get('prop_finder_user_prop') ? Cookies.get('prop_finder_user_prop') : ''
            })
            .catch(function(error) {
              console.log(error)
            })
        },
        fetchProps: function() {
          if (this.make === '' || this.year === ''  || this.model === '') {
            return
          }

          this.selectionResult = _.filter(this.boatOptions, _.matches({
            'make': this.make,
            'year': this.year,
            'model': this.model
          }))

          var vm = this
          console.log(vm.selectionResult)
          axios
            .get(vm.selectionResult[0].jsonUrl)
            .then(function(response) {
              vm.props = response.data.props
              console.log(response)
            })
            .catch(function(error) {
              console.log("here")
              console.log(error)
            })
        },
        updateHighlightProp: function() {
          if (
            this.wakeOptionChecked === null ||
            this.weightOptionChecked === null ||
            this.elevationOptionChecked === null
          ) {
            return
          }

          var propResult =
            _standardProp +
            (this.gaugeData.wake[this.wakeOptionChecked].modifier +
              this.gaugeData.weight[this.weightOptionChecked].modifier +
              this.gaugeData.elevation[this.elevationOptionChecked].modifier)
          if (propResult >= _totalProps) {
            this.highlightProp = _totalProps
          } else if (propResult <= 1) {
            this.highlightProp = 1
          } else {
            this.highlightProp = propResult
          }
        },
        updateMake: function(value) {
          this.resetGauges()
          if(this.prePopulating == false) {
            this.year = ''
            this.model = ''
            this.userProp = ''
            this.make = value
          }
          allYears = _.filter(this.boatOptions, ['make', this.make])
          this.years = _.uniqBy(allYears, 'year')
        },
        updateYear: function(value) {
          this.resetGauges()
          if(this.prePopulating == false) {
            this.model = ''
            this.userProp = ''
          }
          this.models = _.filter(this.boatOptions, {
            make: this.make,
            year: this.year
          })
        },
        updateModel: function() {
          this.resetGauges()
          if(this.prePopulating == false) {
            this.userProp = ''
          }
          this.prePopulating = false
          this.fetchProps()
          this.setCookies()
          this.initGauges()
        },
        updateUserProp: function() {
          if (this.make === '' || this.year === '' || this.model === '') {
            return
          }
          this.prePopulating = false
          this.setCookies()
          this.initGauges()
        },
        setCookies: function() {
          Cookies.set('prop_finder_make', this.make, { expires: 1 })
          Cookies.set('prop_finder_model', this.model, { expires: 1 })
          Cookies.set('prop_finder_year', this.year, { expires: 1 })
          Cookies.set('prop_finder_user_prop', this.userProp, { expires: 1 })
        },
        initGauges: function() {
          this.gaugesActive = true
          this.highlightProp = _standardProp
          this.wakeOptionChecked = 1
          this.weightOptionChecked = 1
          this.elevationOptionChecked = 0
        },
        resetGauges: function() {
          this.gaugesActive = false
          this.highlightProp = _standardProp
          this.wakeOptionChecked = null
          this.weightOptionChecked = null
          this.elevationOptionChecked = null

          for (var key in this.props) {
            this.props[key] = '----'
          }
        },
        sortArray(arrays, value, direction) {
          return _.orderBy(arrays, value, direction);
        },
        toggleModal() {
          if(this.showModal) {
            this.showModal = false
          } else {
            this.showModal = true
          }
        },
      }
    })
  }

  PropFinder.prototype = $.extend({}, PropFinder.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace)
    }
  })

  return PropFinder
})()

/**
 * Shop Specs Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the shop specs section.
 *
   * @namespace shopSpecs
 */

theme.ShopSpecs = (function() {
  function ShopSpecs(container) {
    const sectionId = $(container).attr('id')
    const collectionHandle = $(container).attr('data-shop-specs')
    const shopSpecsComponent = new Vue({
        el: '#' + sectionId,
        delimiters: ['${', '}'],
        data: {
          counter: 0,
          products: [],
          tags: [],
          rotations: [
            { label: "L", value: "Left" },
            { label: "R", value: "Right" }
          ],
          bores: [],
          hubLengths: [],
          diameters: [],
          filters: {
            rotation: {
              label: 'Rotation',
              value: []
            },
            bore: {
              label: 'Bore',
              value: ''
            },
            hubLength: {
              label: 'Hub Length',
              value: ''
            },
            diameter: {
              label: 'Diameter',
              value: []
            }
          },
          visible: false,
          loading: false,
          prePopulating: true,
          buttonActive: false,
          collectionHandle: collectionHandle,
        },
        beforeMount: function() {
          // Build product query from cookies
          for(var key in this.filters) {
            var filterLabel = this.filters[key].label
            var formattedFilterLabel = this.filters[key].label.replace(/\s+/g, '-').toLowerCase()
            var cookie = Cookies.get('acme-' + this.collectionHandle + '-' + formattedFilterLabel)
            if(cookie) {
              cookie = decodeURI(cookie)
              if(cookie.startsWith("[")) {
                this.filters[key].value = JSON.parse(cookie)
                for(i = 0; i < this.filters[key].value.length; i++) {
                  if(filterLabel == 'Diameter') {
                    this.diameters.push('Diameter: ' + this.filters[key].value[i])
                  }
                }
              } else {
                this.filters[key].value = cookie
                if(filterLabel == 'Bore') {
                  this.bores.push('Bore: ' + cookie)
                } else if(filterLabel == 'Hub Length') {
                  this.hubLengths.push('Hub Length: ' + cookie)
                }
              }
            }
          }

          // Switch off prePopulating flag
          this.prePopulating = false
        },
        watch: {
          filters: {
            deep: true,
            handler(filters) {
              if(filters.rotation.value.length > 0 && !filters.diameter.value.length > 0 && this.prePopulating == false) {
                this.updateFilters()
              }

              if(filters.diameter.value.length > 0 && this.prePopulating == false) {
                this.buttonActive = true
              }
            }
          }
        },
        methods: {
          fetchProducts: function(cursor, initialFetch) {
            this.visible = true
            this.loading = true
            this.products = []
            this.tags = []

            const vm = this
            const token = 'c6ddd08fc0916ead35e8806c11734838'
            const url = 'https://acmemarine.myshopify.com/api/2023-07/graphql.json'
            const variables = {
              orderNum: 250,
              cursor: cursor,
              query: vm.buildQueryString()
            }

            const query = `
              query($orderNum: Int!, $cursor: String, $query: String) {
                products(first: $orderNum, after: $cursor, query: $query) {
                  edges {
                    cursor
                    node {
                      tags
                    }
                  }
                  pageInfo {
                    hasNextPage
                    hasPreviousPage
                  }
                }
              }
            `
            $.ajax({
              headers: {
                'X-Shopify-Storefront-Access-Token': token,
                'Content-Type': 'application/json'
              },
              type: 'POST',
              url: url,
              data: JSON.stringify({
                query: query,
                variables: variables
              }),
              success: function(results) {
                const products = results.data.products.edges
                const hasNextPage = results.data.products.pageInfo.hasNextPage
                if(products) {
                  for(var i = 0; i < products.length; i++) {
                    vm.products.push(products[i])
                    if(products[i].node.tags.length > 0) {
                      var tags = products[i].node.tags
                      for(var x = 0; x < tags.length; x++) {
                        if(!vm.tags.includes(tags[x])){
                          vm.tags.push(tags[x])
                        }
                      }
                    }
                  }

                  if(hasNextPage) {
                    vm.fetchProducts(products[products.length-1].cursor)
                  } else {
                    if(vm.filters.bore.value.length == 0 || initialFetch == true) {
                      vm.bores = _.filter(vm.tags, function(item) {
                        return item.includes('Bore:')
                      })
                    }
                    if(vm.filters.hubLength.value.length == 0 || initialFetch == true) {
                      vm.hubLengths = _.filter(vm.tags, function(item) {
                        return item.includes('Hub Length:')
                      })
                    }
                    if(vm.filters.diameter.value.length == 0 || initialFetch == true) {
                      vm.diameters = _.filter(vm.tags, function(item) {
                        return item.includes('Diameter:')
                      })
                    }
                    vm.loading = false
                  }
                }
              },
              error: function(errors) {
                vm.loading = false
                console.log(errors)
              }
            })
          },
          updateFilters() {
            this.fetchProducts()
          },
          formatSpec(spec) {
            if(spec) {
              var specArray = spec.split(": ")
              if(specArray.length > 1) {
                return specArray[1]
              }
            }
          },
          buildQueryString() {
            var queryString = ''

            if(this.collectionHandle == 'wake-ski' || this.collectionHandle == 'sport') {
              queryString += 'tag:Wake/Ski '
            } else if(this.collectionHandle == 'cruiser') {
              queryString += 'tag:Cruiser '
            }

            for(var key in this.filters) {
              if(this.filters[key].value) {
                if(this.filters[key].value.constructor === Array) {
                  for(i = 0; i < this.filters[key].value.length; i++) {
                    if (i != this.filters[key].value.length - 1) {
                      queryString += "tag:'" + this.filters[key].label + ": " + this.filters[key].value[i] + "' OR "
                    } else {
                      queryString += "tag:'" + this.filters[key].label + ": " + this.filters[key].value[i] + "' "
                    }
                  }
                } else {
                  queryString += "tag:'" + this.filters[key].label + ": " + this.filters[key].value + "' "
                }
              }
            }

            console.log(queryString)
            return queryString
          },
          sortArray(array, value, direction) {
            return _.orderBy(array)
          },
          submit() {
            for(var key in this.filters) {
              if(this.filters[key].value.length > 0) {
                Cookies.set('acme-' + this.collectionHandle + '-' + this.filters[key].label.replace(/\s+/g, '-').toLowerCase(), this.filters[key].value)
              }
            }
            window.location.href = '/collections/' + this.collectionHandle + '?rotation=' + this.filters.rotation.value + '&bore=' + this.filters.bore.value + '&hubLength=' + this.filters.hubLength.value + '&diameter=' + this.filters.diameter.value
          },
          clearSpecs() {
            // Switch off prePopulating flag so we don't fetch products
            this.prePopulating = true

            // Clear filters & remove cookies
            for(var key in this.filters) {
              var filterLabel = this.filters[key].label
              var formattedFilterLabel = this.filters[key].label.replace(/\s+/g, '-').toLowerCase()
              Cookies.remove('acme-' + this.collectionHandle + '-' + formattedFilterLabel)
              if(this.filters[key].value.constructor === Array) {
                this.filters[key].value = []
              } else {
                this.filters[key].value = ""
              }
            }

            // Switch off prePopulating flag so we don't fetch products
            this.prePopulating = false
          },
          getDisabledState(previousStep) {
            if(this.collectionHandle == 'cruiser') {
              if(this.filters.bore.value === '') {
                this.buttonActive = true
                return true
              } else {
                return false
              }
            } else {
              if(previousStep === '') {
                return true
              } else {
                return false
              }
            }
          }
        }
      })
  }

  ShopSpecs.prototype = $.extend({}, ShopSpecs.prototype, {
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace)
    }
  })

  return ShopSpecs
})()


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('carousel', theme.Carousel);
  sections.register('collection', theme.Collection);
  sections.register('dealerLocator', theme.DealerLocator);
  sections.register('finder', theme.Finder);
  sections.register('header', theme.Header);
  sections.register('instagram', theme.Instagram);
  sections.register('partners', theme.Partners);
  sections.register('product', theme.Product);
  sections.register('propFinder', theme.PropFinder);
  sections.register('shopSpecs', theme.ShopSpecs);

  // Init Cart Scripts
  slate.cart.init();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));
  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.c-rte table';
  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'c-rte__table-wrapper'
  });

  // Target iframes to make them responsive
  var iframeSelectors = '.c-rte iframe[src*="youtube.com/embed"],' + '.c-rte iframe[src*="player.vimeo"]';
  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'c-rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Tabs
  ButaneTabs.init();

  // Accordions
  ButaneAccordion.init();

  // Ajax pagination
  ajaxify({
    linkParent: '[data-pagination]',
    parentContainer: '[data-ajax-container]'
  });

  // Back to Top Button
  var backToTop = '[data-back-to-top]';

  // Scroll back to top on button click
  $(backToTop).click(function () {
    $('html, body').animate({
      scrollTop: 0
    }, "slow");
    return false;
  });

  // Show button on window scroll
  $(window).scroll(function () {
    var windowHeight = $(window).height() * 3;
    if ($(this).scrollTop() > windowHeight) {
      $(backToTop).addClass('is-visible');
    } else {
      $(backToTop).removeClass('is-visible');
    }
  });
});